// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_IXizM","reward_num":"reward_num_cdvFu"};